import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaProgressCircle } from "./VaProgressCircle-cafc6b7b.mjs";
const VaProgressCircle = withConfigTransport(_VaProgressCircle);
export {
  VaProgressCircle as V
};
//# sourceMappingURL=index-0664da55.mjs.map
